import { Selector } from '@ngxs/store';

import {
  FilteringConfig,
  FilterOptions,
  GridConfig,
} from '@customer-portal/shared';
import {
  applyGridConfig,
  getNumberOfFilteredRecords,
  isAnyFilterActive,
} from '@customer-portal/shared/helpers';

import { SettingsSitesItemModel } from '../../models';
import { SettingsSitesState, SitesStateModel } from '../settings-site.state';

export class SettingsSitesSelectors {
  @Selector([SettingsSitesSelectors._settingsSitesList])
  static settingsSitesList(
    settingsSitesList: SettingsSitesItemModel[],
  ): SettingsSitesItemModel[] {
    return settingsSitesList;
  }

  @Selector([SettingsSitesSelectors._sitesTotalFilteredRecords])
  static sitesTotalFilteredRecords(sitesTotalFilteredRecords: number): number {
    return sitesTotalFilteredRecords;
  }

  @Selector([SettingsSitesSelectors._sitesFilterOptions])
  static sitesFilterOptions(sitesFilterOptions: FilterOptions): FilterOptions {
    return sitesFilterOptions;
  }

  @Selector([SettingsSitesSelectors._sitesFilteringConfig])
  static sitesFilteringConfig(
    sitesFilteringConfig: FilteringConfig,
  ): FilteringConfig {
    return sitesFilteringConfig;
  }

  @Selector([SettingsSitesSelectors._sitesGridConfig])
  static sitesGridConfig(sitesGridConfig: GridConfig): GridConfig {
    return sitesGridConfig;
  }

  @Selector([SettingsSitesSelectors._hasSitesActiveFilters])
  static hasSitesActiveFilters(hasSitesActiveFilters: boolean): boolean {
    return hasSitesActiveFilters;
  }

  @Selector([SettingsSitesState])
  static selectedSite(state: SitesStateModel): SettingsSitesItemModel | null {
    return (
      state.sitesList.find(
        (site) => String(site.id) === String(state.selectedSiteId),
      ) ?? null
    );
  }

  @Selector([SettingsSitesState])
  static isSiteNicknameSubmitting(state: SitesStateModel): boolean {
    return state.isSubmittingSiteNickname;
  }

  @Selector([SettingsSitesState])
  static siteNicknameError(state: SitesStateModel): string | null {
    return state.siteNicknameError;
  }

  @Selector([
    SettingsSitesSelectors._sitesList,
    SettingsSitesSelectors._sitesGridConfig,
  ])
  private static _settingsSitesList(
    sitesList: SettingsSitesItemModel[],
    sitesGridConfig: GridConfig,
  ): SettingsSitesItemModel[] {
    return applyGridConfig(sitesList, sitesGridConfig);
  }

  @Selector([
    SettingsSitesSelectors._sitesList,
    SettingsSitesSelectors._sitesGridConfig,
  ])
  private static _sitesTotalFilteredRecords(
    sitesList: SettingsSitesItemModel[],
    sitesGridConfig: GridConfig,
  ): number {
    return getNumberOfFilteredRecords(sitesList, sitesGridConfig);
  }

  @Selector([SettingsSitesState])
  private static _sitesList(state: SitesStateModel): SettingsSitesItemModel[] {
    return state.sitesList;
  }

  @Selector([SettingsSitesState])
  private static _sitesGridConfig(state: SitesStateModel): GridConfig {
    return state.sitesGridConfig;
  }

  @Selector([SettingsSitesState])
  private static _sitesFilterOptions(state: SitesStateModel): FilterOptions {
    return state.sitesFilterOptions;
  }

  @Selector([SettingsSitesState])
  private static _sitesFilteringConfig(
    state: SitesStateModel,
  ): FilteringConfig {
    return state.sitesGridConfig.filtering;
  }

  @Selector([SettingsSitesState])
  private static _hasSitesActiveFilters(state: SitesStateModel): boolean {
    return isAnyFilterActive(state.sitesGridConfig.filtering);
  }
}
